/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
import * as z from "zod";
export const OrderBillingReason = {
    Purchase: "purchase",
    SubscriptionCreate: "subscription_create",
    SubscriptionCycle: "subscription_cycle",
    SubscriptionUpdate: "subscription_update",
};
/** @internal */
export const OrderBillingReason$inboundSchema = z.nativeEnum(OrderBillingReason);
/** @internal */
export const OrderBillingReason$outboundSchema = OrderBillingReason$inboundSchema;
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export var OrderBillingReason$;
(function (OrderBillingReason$) {
    /** @deprecated use `OrderBillingReason$inboundSchema` instead. */
    OrderBillingReason$.inboundSchema = OrderBillingReason$inboundSchema;
    /** @deprecated use `OrderBillingReason$outboundSchema` instead. */
    OrderBillingReason$.outboundSchema = OrderBillingReason$outboundSchema;
})(OrderBillingReason$ || (OrderBillingReason$ = {}));
//# sourceMappingURL=orderbillingreason.js.map